import * as React from 'react';
import makeAnimated from 'react-select/animated';
import { tagsProvider } from '../../../../data/providers/tagsProvider';
import { toOptions } from '../../../../data/providers/utils/toOptions';
import { ISelectableTag } from '../../../../data/types';
import { Select } from '../Select';

interface IProps {
  value: ISelectableTag;
  disabled?: boolean;
  onChange: (c: ISelectableTag) => void;
  id?: string;
}
const SingleTagSelect = (props: IProps): React.ReactElement => {
  const [options, setOptions] = React.useState<ISelectableTag[]>([]);

  React.useEffect((): (() => void) => {
    const subscriber = tagsProvider()
      .pipe(toOptions)
      .subscribe((items: ISelectableTag[]): void => {
        setOptions(
          items.filter(
            (item: ISelectableTag): boolean =>
              !item.entity.exclude_aggregates && item.entity.active
          )
        );
      });
    return (): void => {
      subscriber.unsubscribe();
    };
  }, []);

  const handleChange = (s: ISelectableTag): void => props.onChange(s);

  return (
    <Select
      options={options}
      controlShouldRenderValue
      value={props.value}
      isDisabled={props.disabled}
      placeholder='Tag...'
      components={makeAnimated()}
      onChange={handleChange}
      cache={false}
      inputId={props.id ?? 'tag-select'}
    />
  );
};

export { SingleTagSelect };
